<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    <h2>Modificación a tarifas base</h2>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Porcentaje de comisión por uso de aplicación">
                <a-input
                  placeholder="Porcentaje de comisión por uso de aplicación"
                  v-model="$v.fare.appCharge.$model"
                >
                 <a-icon slot="addonAfter" type="percentage" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.appCharge.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.appCharge.numeric || parseInt($v.fare.appCharge.$model) < 0">Ingresa un valor entero positivo</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Costo de banderazo">
                <a-input
                  placeholder="Costo de banderazo"
                  v-model="$v.fare.startedPrice.$model"
                >
                 <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.startedPrice.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.startedPrice.decimal">Campo decimal</small>
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Costo por tiempo">
                <a-input
                  placeholder="Costo por tiempo"
                  v-model="$v.fare.timeFare.$model"
                >
                <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.timeFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.timeFare.decimal">Campo decimal</small>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <a-form-item label="Costo por distancia 1">
                <a-input
                  placeholder="Costo por distancia 1"
                  v-model="$v.fare.distanceShortFare.$model"
                >
                <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.distanceShortFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.distanceShortFare.decimal">Campo decimal</small>
              </a-form-item>
            </div>
            <div class="col-md-2">
              <a-form-item label="Costo por distancia 2">
                <a-input
                  placeholder="Costo por distancia 2"
                  v-model="$v.fare.distanceLongFare.$model"
                >
                <a-icon slot="addonBefore" type="dollar" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.distanceLongFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.distanceLongFare.decimal">Campo numerico</small>
              </a-form-item>
            </div>
            <div class="col-md-8">
              <a-form-item label="Porcentaje de tarifa nocturna">
                <a-input
                  placeholder="Porcentaje de tarifa nocturna"
                  v-model="$v.fare.nightFare.$model"
                >
                <a-icon slot="addonAfter" type="percentage" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.nightFare.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.appCharge.numeric || parseInt($v.fare.appCharge.$model) < 0">Ingresa un valor entero positivo</small>
              </a-form-item>
            </div>
          </div>
          <!--
          <div class="row">
            <h2>Tarifa plana</h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <a-form-item label="Inicio de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeStartHour1" />
                <small class="text-danger" v-if="!$v.fare.startHour1.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-3">
              <a-form-item label="Fin de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeEndHour1" ></a-time-picker>
                <small class="text-danger" v-if="!$v.fare.endHour1.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Cargo por hora pico">
                <a-input
                  placeholder="Cargo por hora pico"
                  v-model="$v.fare.rushHourCharge.$model">
                  <a-icon slot="addonAfter" type="percentage" />
                </a-input>
                <small class="text-danger" v-if="!$v.fare.rushHourCharge.required">Campo requerido. No debe estar vacío</small>
                <small class="text-danger" v-if="!$v.fare.rushHourCharge.decimal">Campo decimal</small>
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <a-form-item label="Inicio de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeStartHour2" />
                <small class="text-danger" v-if="!$v.fare.startHour2.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-3">
              <a-form-item label="Fin de hora pico">
                <a-time-picker :default-open-value="moment('00:00', 'HH:mm')" format="HH:mm" @change="onChangeEndHour2" ></a-time-picker>
                <small class="text-danger" v-if="!$v.fare.endHour2.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
          </div>-->
          <div class="row">
            <div class="col-12">
              <a-form-item>
                <b-button
                  :disabled="$v.$invalid"
                  block
                  type="submit"
                  class="btn px-5"
                >
                  Registrar
                </b-button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
    <FareList ref="listComponent"/>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required, numeric, decimal } from 'vuelidate/lib/validators'
import FareList from './fare-list/fare-list'
import headers from '@/config/headers.js'
import moment from 'moment'
const CREATE_FARE = gql`
  mutation createFare($createdBy: String, $appCharge: Float, $startedPrice: Float, $date: String, $distanceLongFare: Float, $distanceShortFare: Float, $nightFare: Float, $timeFare: Float){
    createFare(fare: { createdBy: $createdBy, appCharge: $appCharge, startedPrice: $startedPrice, date: $date, distanceLongFare: $distanceLongFare,  distanceShortFare: $distanceShortFare, nightFare: $nightFare, timeFare: $timeFare}){
      createdBy
      startedPrice
      appCharge
      date
      distanceLongFare
      distanceShortFare
      nightFare
      timeFare
      createdAt
    }
  }
`
export default {
  components: {
    FareList,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      disabledButton: false,
      fare: {
        appCharge: '',
        startedPrice: '',
        timeFare: '',
        distanceShortFare: '',
        distanceLongFare: '',
        nightFare: '',
        key: 0,
      },
    }
  },
  methods: {
    moment,
    addTimeRange() {
      if (this.startHour < this.endHour) {
        this.fare.timeRange.add({ startHour: this.startHour, endHour: this.endHour })
      }
      console.log(this.fare.timeRange)
    },
    onChangeStartHour1(time, timeString) {
      this.fare.startHour1 = timeString
      if (this.fare.startHour1 < this.fare.endHour1) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour1, this.fare.endHour1)
      }
    },
    onChangeEndHour1(time, timeString) {
      this.fare.endHour1 = timeString
      if (this.fare.startHour1 < this.fare.endHour1) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour1, this.fare.endHour1)
      }
    },
    onChangeStartHour2(time, timeString) {
      this.fare.startHour2 = timeString
      if (this.fare.startHour2 < this.fare.endHour2) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour2, this.fare.endHour2)
      }
    },
    onChangeEndHour2(time, timeString) {
      this.fare.endHour2 = timeString
      if (this.fare.startHour2 < this.fare.endHour2) {
        console.log('greater')
        console.log(time, timeString)
      } else {
        console.log(this.fare.startHour2, this.fare.endHour2)
      }
    },
    handleSubmit() {
      this.loading = true
      const fareData = { ...this.fare }
      console.log(fareData)
      this.clearForm()
      this.$apollo.mutate({
        mutation: CREATE_FARE,
        variables: {
          createdBy: this.$store.state.user.email,
          appCharge: parseFloat(fareData.appCharge) / 100,
          startedPrice: parseFloat(fareData.startedPrice),
          date: new Date(),
          distanceLongFare: parseFloat(fareData.distanceLongFare),
          distanceShortFare: parseFloat(fareData.distanceShortFare),
          nightFare: parseFloat(fareData.nightFare) / 100,
          timeFare: parseFloat(fareData.timeFare),
          // timeRange: [{ startHour: fareData.startHour1, endHour: fareData.endHour1 }, { startHour: fareData.startHour2, endHour: fareData.endHour2 }],
          // rushHourCharge: parseFloat(fareData.rushHourCharge),
        },
        context: headers(),
      })
        .then(data => {
          this.loading = false
          // this.$router.push('/montos/crearTarifa')
          this.$refs.listComponent.refetchQuery()
          // this.$refs.listComponent.showComponent()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    clearForm() {
      this.fare.appCharge = ''
      this.fare.startedPrice = ''
      this.fare.timeFare = ''
      this.fare.distanceShortFare = ''
      this.fare.distanceLongFare = ''
      this.fare.nightFare = ''
      this.fare.rushHourCharge = ''
    },
  },
  validations: {
    fare: {
      appCharge: { required, numeric },
      startedPrice: { required, decimal },
      timeFare: { required, decimal },
      distanceShortFare: { required, decimal },
      // rushHourCharge: { required, decimal },
      distanceLongFare: { required, decimal },
      nightFare: { required, numeric },
      // startHour1: { required },
      // endHour1: { required },
      // startHour2: { required },
      // endHour2: { required },
    },
  },
}
</script>
